import angular from 'angular';
import searchApointmentComponent from './search-appointment.component';

const searchApointment = angular
	.module('searchApointment', [])
	.component('searchApointment', searchApointmentComponent)
	.name;

export default searchApointment;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/search-appointment/search-appointment.modules.js